import router from "../router"
import axios from "axios"

/*
关联Vue,一定"./utils/msg"的init_msg的函数执行后才能执行init_axios
才可以正常调用消息提示方法

请求正常回应:
  response [完整回应对象]
  response.data [数据]
请求异常回应:
  40-*, 或者代码本身的错误!
  err.response [完整回应对象]
  err.response.data [数据]
现配置了axios：
  请求的认证头部
  请求拦截器:
    pass
  回应拦截器:
    401-未授权，重定向至登录界面
    403-权限禁止，提示消息
    其他错误-400/404/500/...,提示消息
    一般请求不捕捉catch了，但有需要依然可以catch到
*/

function init_axios(Vue) {
  // create an axios instance
  const request = axios.create({
    // baseURL: process.env.BASE_API  // 请求的api,开发/生产时不同BASE_API
    baseURL: localStorage.getItem("current_school_url") || process.env.BASE_API
  });

  var token = localStorage.getItem("token");
  if (token) {
    request.defaults.headers.common["Authorization"] = localStorage.getItem("token");
  }


  // axios请求拦截器
  request.defaults.timeout = 1000 * 300;
  request.interceptors.request.use(function (config) {
    // Do something before request is sent
    // console.log(config);  // config配置信息
    if (false) {
      // 判断阻止请求的条件
      return  // return即不请求
    }
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });


  // axios回应拦截器
  request.interceptors.response.use(function (response) {
    // 正常返回数据
    return response;
  }, function (err) {
    let status = err.response.status;
    let data = err.response.data.data;
    if (status === 401) {
      // 返回401状态码时 跳转login页面
      let current_path = router.currentRoute.path;
      if (current_path !== "/login") {
        router.replace({
          path: "/login",  // login url
          query: {redirect: router.currentRoute.fullPath}  // 用于登录后可以根据这个重定向至之前界面
        })
      }
    } else if (status === 403 || status === 404) {
      if (status === 404 && err.response.config.url.indexOf("use_deadline_info") > -1) {
        // 排除获取平台信息接口，旧版本没有此接口为404
      } else {
        Vue.msg.toast(data, "error")
      }
    } else {
      // 400, 500, *
      Vue.msg.toast(data, "error")
    }
    return Promise.reject(err);
  });

  // Vue添加原型
  Vue.prototype.$http = request;
}

export default init_axios;



// WEBPACK FOOTER //
// ./src/utils/axios.js